import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let cached: SupabaseClient | null = null;

export function getSupabase(opts?: { forceReinit?: boolean }): SupabaseClient {
  if (cached && !opts?.forceReinit) return cached;

  const url = import.meta.env.VITE_SUPABASE_URL;
  const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!url) throw new Error('VITE_SUPABASE_URL is not set');
  if (!anon) throw new Error('VITE_SUPABASE_ANON_KEY is not set');

  cached = createClient(url, anon, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  return cached;
}
